export enum ThreeDS2Provider {
  Adyen = 'adyen',
  AdyenBank = 'adyen_bank',
}
